<template>
    <v-toolbar class="top_navbar">
        <div class="toggle_icon">
            <button class="navbar-toggle" @click="sidebarToggle" data-toggle="collapse" data-target="#myNavbar">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span> 
            </button>
      </div>
        <img src="@/assets/cmst_logo.png" alt="CMST" class="logo_img">
    <v-toolbar-title class="white--text t_title">CONSULTANCY FINDER</v-toolbar-title>
    <v-spacer class="space_item" ></v-spacer>
    <v-flex>
        <v-text-field v-model="search" label="Search" placeholder="Search Consultancy" class="search_bar" solo></v-text-field>
    </v-flex>
    <v-flex v-if="toggleSearch">
        <v-text-field v-model="search" label="Search" placeholder="Search Consultancy" class="mbl_search_bar" solo></v-text-field>
    </v-flex>
    <div class="search_icon">
        <v-btn icon @click="searchToggle" >
            <v-icon>search</v-icon>
        </v-btn>
    </div>
    <v-spacer class="space_item"></v-spacer>
    <v-toolbar-items >
        <v-btn v-if="isLoggedIn" flat class="white--text " @click="logOut" >LOG OUT</v-btn>
        <span v-else class="login_signup " id="hide_header_items">
            <v-btn  flat class="white--text " @click="$router.push('/login')" >LOGIN</v-btn>
            <v-btn  flat class="white--text " @click="$router.push('/signup')" >SIGN UP</v-btn>
        </span>
    </v-toolbar-items>
    <v-progress-linear
        :active="loader"
        :indeterminate="loader"
        class="loader_container"
        absolute
        bottom
        color="#3cb371"
        ></v-progress-linear>
    </v-toolbar>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    data(){
        return {
            search: '',
            toggleSidebar: true,
            toggleSearch: false, 
        }
    },
    watch: {
        search(val){
            this.$store.commit('SEARCH', val)
            this.$router.push('/')
        },
        $route(to, from){
            this.search = '';
        }
    },
    methods: {
        logOut(){
            localStorage.removeItem('applicant');
            this.$store.commit('AUTH', false);
            this.$router.push('/login');
        },
        sidebarToggle(){
            this.toggleSidebar = !this.toggleSidebar;
            this.$store.commit('NAVBAR',this.toggleSidebar);
        },
        searchToggle(){
            this.toggleSearch = !this.toggleSearch;
        }
    },
    computed: {
        ...mapGetters(['isLoggedIn','consultancies','loader','toggle'])
    }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/Header.vue